module.exports = __webpack_public_path__ + "close-icon-1af9a0e66c5dde93a5c5.svg";